import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  go(event) {
    const target = event.detail.element || event.target
    const scroll = !!event.detail.scroll || true

    this.#openParentTab(target)
    this.#openParentDetails(target)

    if (scroll) {
      target.scrollIntoView()
    }
  }

  #openParentTab(element) {
    const tabParent = element.closest("[data-tabs-target='panel']")
    if (tabParent) {
      const tab = document.querySelector(`[name="${tabParent.getAttribute("id")}"]`)
      // Manually firing the click event on a Node is bad. Sorry, we
      // know.  This could probably be done in another way someday.
      tab && tab.click()
    }
  }

  #openParentDetails(element, isLeaf = true) {
    const parent = element.parentNode.closest("details")
    if (!parent) {
      return false
    }
    if (!parent.hasAttribute("open")) {
      parent.setAttribute("open", true)
    }
    isLeaf ? parent.classList.add("active") : parent.classList.remove("active")

    return this.#openParentDetails(parent, false)
  }
}
